import { useEffect } from 'react';

import { useNavigate } from '@cast/infrastructure-organization';

import {
  clearCastAiWebCookie,
  getCastAiWebCookie,
  ProductValues,
} from 'core/cookies';

const redirectMap: Record<ProductValues, string | undefined> = {
  security: '/organization/security/dashboard',
  reporting: undefined,
};

export const useConsumeCastAiWebCookie = (isLoading: boolean) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) {
      return;
    }
    const cookie = getCastAiWebCookie();

    if (cookie) {
      clearCastAiWebCookie();
    }

    if (!cookie?.product) {
      return;
    }

    const redirectPath = redirectMap[cookie.product];
    if (!redirectPath) {
      return;
    }

    let redirectTo = redirectPath;
    if (cookie.redirectQueryParams) {
      redirectTo += `&${cookie.redirectQueryParams}`;
    }

    navigate(redirectTo.toString(), { replace: true });
  }, [isLoading, navigate]);
};
